export interface Result<T = undefined> {
  data: T;
}
